(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qb-main-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var opener = event.target.closest('[data-qb-size-open]');
    if (opener) { var dialog = document.getElementById(opener.getAttribute('aria-controls')); if (dialog) dialog.showModal(); }
    var closer = event.target.closest('[data-qb-size-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('.qb-product__size-dialog')) { var box = event.target.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close(); }
  });

  function qbSelectProductMedia(root, media, scroll) {
    root.querySelectorAll('[data-qb-product-media]').forEach(function(item) {
      item.classList.toggle('is-selected', item === media);
      if (item !== media) item.querySelectorAll('video').forEach(function(video) { video.pause(); });
    });
    root.querySelectorAll('[data-qb-media-select]').forEach(function(button) {
      if (button.dataset.qbMediaSelect === media.dataset.qbMediaId) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
    var thumbs = Array.from(root.querySelectorAll('[data-qb-media-select]'));
    var activeIndex = thumbs.findIndex(function(thumb) { return thumb.dataset.qbMediaSelect === media.dataset.qbMediaId; });
    root.querySelectorAll('[data-qb-gallery-step]').forEach(function(step) {
      var next = thumbs[activeIndex + Number(step.dataset.qbGalleryStep)];
      step.disabled = !next;
      if (next) step.setAttribute('aria-label', next.getAttribute('aria-label'));
    });
    if (scroll && thumbs[activeIndex]) {
      var strip = thumbs[activeIndex].parentElement;
      strip.scrollTo({left: thumbs[activeIndex].offsetLeft - strip.offsetLeft - 5, behavior: 'smooth'});
    }
    if (scroll) media.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest', inline: 'start' });
  }

  document.addEventListener('click', function(event) {
    var step = event.target.closest('[data-qb-gallery-step]');
    if (step) {
      var galleryRoot = step.closest('[data-qb-product]');
      var items = Array.from(galleryRoot.querySelectorAll('[data-qb-product-media]'));
      var current = items.findIndex(function(item) { return item.classList.contains('is-selected'); });
      var target = items[current + Number(step.dataset.qbGalleryStep)];
      if (target) qbSelectProductMedia(galleryRoot, target, true);
      return;
    }
    var button = event.target.closest('[data-qb-media-select]');
    if (!button) return;
    var root = button.closest('[data-qb-product]');
    var media = root.querySelector('[data-qb-product-media][data-qb-media-id="' + button.dataset.qbMediaSelect + '"]');
    if (media) qbSelectProductMedia(root, media, true);
  });

  document.addEventListener('keydown', function(event) {
    var button = event.target.closest('[data-qb-media-select]');
    if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    var buttons = Array.from(button.parentElement.querySelectorAll('[data-qb-media-select]'));
    var index = buttons.indexOf(button);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = buttons.length - 1;
    else index = Math.max(0, Math.min(buttons.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
    event.preventDefault();
    buttons[index].focus({preventScroll: true});
    buttons[index].click();
  });

  function qbObserveProductGallery(root) {
    if (root.dataset.qbGalleryReady) return;
    root.dataset.qbGalleryReady = 'true';
    var gallery = root.querySelector('.qb-product__gallery');
    var media = Array.from(root.querySelectorAll('[data-qb-product-media]'));
    if (!gallery || !media.length) return;
    var observer = new IntersectionObserver(function(entries) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      entries.forEach(function(entry) {
        if (entry.intersectionRatio > .6) qbSelectProductMedia(root, entry.target, false);
      });
    }, {root: gallery, threshold: .6});
    media.forEach(function(item) { observer.observe(item); });
  }

  document.querySelectorAll('[data-qb-product]').forEach(qbObserveProductGallery);
  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[data-qb-product]').forEach(qbObserveProductGallery);
  });

  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-qb-option]')) return;

    var root = event.target.closest('[data-qb-product]');
    if (!root) return;

    var jsonNode = root.querySelector('[data-qb-variants]');
    var input = root.querySelector('[data-qb-variant-input]');
    var button = root.querySelector('[data-qb-add-to-cart]');
    var buttonText = root.querySelector('[data-qb-add-text]');
    var price = root.querySelector('[data-qb-product-price]');
    if (!jsonNode || !input || !button) return;

    var variants = JSON.parse(jsonNode.textContent);
    var selected = Array.from(root.querySelectorAll('[data-qb-option-group]')).map(function(group) {
      var checked = group.querySelector('[data-qb-option]:checked');
      var field = checked || group.querySelector('[data-qb-option]');
      return field ? field.value : null;
    });
    var variant = variants.find(function(item) {
      return item.options.every(function(option, index) {
        return option === selected[index];
      });
    });

    if (!variant) {
      button.disabled = true;
      if (buttonText) buttonText.textContent = root.dataset.unavailableLabel;
      return;
    }

    input.value = variant.id;
    button.disabled = !variant.available;
    if (buttonText) buttonText.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldLabel;

    var optionGroup = event.target.closest('[data-qb-option-group]');
    if (optionGroup) {
      var selectedLabel = optionGroup.querySelector('[data-qb-option-selected]');
      if (selectedLabel) selectedLabel.textContent = event.target.value;
    }

    if (price) {
      var currency = root.dataset.currency || 'USD';
      var formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
      var current = formatter.format(variant.price / 100);
      var compare = variant.compare_at_price && variant.compare_at_price > variant.price ? '<s class="qb-price__compare">' + formatter.format(variant.compare_at_price / 100) + '</s> ' : '';
      price.innerHTML = '<span class="qb-price" data-qb-price-display>' + compare + '<span class="qb-price__current">' + current + '</span></span>';
    }

    if (optionGroup && optionGroup.classList.contains('qb-product-form__option--color') && variant.featured_media && variant.featured_media.id) {
      var media = root.querySelector('[data-qb-product-media][data-qb-media-id="' + variant.featured_media.id + '"]');
      if (media) {
        qbSelectProductMedia(root, media, true);
      }
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qb-product-recommendations"]) return;
  try {
    
  document.querySelectorAll('[data-qb-recommendations]').forEach(function(section) {
    if (section.dataset.loaded === 'true') return;

    var loadRecommendations = function() {
      section.dataset.loaded = 'true';
      fetch(section.dataset.url)
        .then(function(response) { return response.text(); })
        .then(function(text) {
          var container = document.createElement('div');
          container.innerHTML = text;
          var replacement = container.querySelector('[data-qb-recommendations]');
          if (replacement && replacement.innerHTML.trim()) {
            section.innerHTML = replacement.innerHTML;
          }
        });
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 300px 0px' });
      observer.observe(section);
    } else {
      loadRecommendations();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
